module.exports = __webpack_public_path__ + "img/29.e045b6ea.jpg";